module.exports = __webpack_public_path__ + "static/LOGO 8-fcd31499a66407d9d97ec11bac1d82a7.png";